import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=4ac53b6a&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Order.vue?vue&type=style&index=1&id=4ac53b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac53b6a",
  null
  
)

export default component.exports